import React from 'react';

import BlockSkeleton from '../Skeleton/BlockSkeleton';
import Classes from './FeedItemSkeleton.module.scss';

const FeedItemSkeleton = () => (
  <div className={Classes.card}>
    <BlockSkeleton className={Classes.image} />
    <BlockSkeleton className={Classes.title} />
    <BlockSkeleton className={Classes.price} />
  </div>
);

export default FeedItemSkeleton;
